// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsManageProtocol_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2 28V0H15V2H4V26H12.5279L13.9405 26.7063C14.0657 27.0793 14.216 27.4406 14.3893 27.7883L14.3187 28H2ZM23 14V8H21V14H23Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M15.8135 26C15.7415 25.7773 15.6813 25.5493 15.6334 25.3167L14 24.5V23.5L15.6334 22.6833C15.8015 21.8662 16.123 21.1051 16.5664 20.4313L15.9884 18.6972L16.6955 17.9901L18.429 18.5679C19.1033 18.1237 19.8652 17.8017 20.6833 17.6334L21.5 16H22.5L23.3167 17.6334C24.1341 17.8016 24.8954 18.1232 25.5693 18.5668L27.3048 17.9884L28.0119 18.6955L27.4334 20.431C27.8769 21.1048 28.1984 21.866 28.3666 22.6833L30 23.5V24.5L28.3666 25.3167C28.1985 26.1338 27.877 26.8949 27.4336 27.5687L28.0116 29.3028L27.3045 30.0099L25.571 29.4321C24.8967 29.8763 24.1348 30.1983 23.3167 30.3666L22.5 32H21.5L20.6833 30.3666C19.8664 30.1985 19.1056 29.8772 18.432 29.434L16.6991 30.0116L15.992 29.3045L16.5692 27.573C16.5347 27.5205 16.5008 27.4676 16.4678 27.4141C16.1961 26.9748 15.9754 26.5007 15.8135 26ZM21.9994 28.5002C24.4847 28.5002 26.4994 26.4855 26.4994 24.0002C26.4994 21.5149 24.4847 19.5002 21.9994 19.5002C19.5141 19.5002 17.4994 21.5149 17.4994 24.0002C17.4994 26.4855 19.5141 28.5002 21.9994 28.5002Z" class="svg-bg"/>
  <path d="M17 0 23 6H17V0ZM15 4H6V6H15V4ZM6 8H19V10H6V8ZM19 12H6V14H19V12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsManageProtocol is a generated icon component.
 */
let IconRmsManageProtocol = IconRmsManageProtocol_1 = class IconRmsManageProtocol extends IconBaseElement {
    render() {
        return html `${IconRmsManageProtocol_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsManageProtocol.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsManageProtocol = IconRmsManageProtocol_1 = __decorate([
    customElement('zui-icon-rms-manage-protocol')
], IconRmsManageProtocol);
export { IconRmsManageProtocol };
